//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ReportInputItem } from './ReportInputItem';
import { ReportType } from './Enums';

export class AttendanceNoteReportInputItem extends ReportInputItem {
    AttendanceID: string | null = null;
    IncludeParentNotes: boolean = false;
    IncludePrivateNotes: boolean = false;
    StudentNoteOverride: string | null = null;
    ParentNoteOverride: string | null = null;
    TeacherNoteOverride: string | null = null;
    override readonly Type: ReportType = ReportType.AttendanceNote;

    constructor(initializer?: Partial<Omit<AttendanceNoteReportInputItem, "Type">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "AttendanceNoteReportInputItem";
}
